
import { Table } from 'react-bootstrap';
import { archivos_necesarios } from '../data/datos';
import InputArchivo from './InputArchivo';

const Archivo = () => {

    return (
        <div className="my-4">
            <hr className='m-5' />
            <p className="lead text-center">
                Debe subir los siguientes documentos.
            </p>

            <div className='table-responsive my-4'>
                <Table bordered hover>
                    <thead>
                        <tr>
                            <th className='text-center' width="75%">Archivo a subir</th>
                            <th className='text-center' width="25%">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        { archivos_necesarios.filter(i => i.mostrar !== false).map((i, index) => <InputArchivo key={index} descripcion={i.descripcion} tipo={i.nombre}/>)}
                    </tbody>
                </Table>
            </div>

        </div>
    )
}

export default Archivo
